import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import Section from "../../common/Section";
import NumberInput from '../../common/NumberInput';
import Form from "../../common/Form";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import * as domainConstants from "../../../constants/DomainConstants";
import * as types from "../../../constants/ComponentConstants";
import Row from "../../common/Row";

const VRVerantwoordingForm = (props) => {
	const {
		vrVerantwoording,
		disabled,
		errors,
		onChange,
		onSave,
		color,
		projectId,
		documenten,
		onDropFiles,
		onDeleteFile,
		fileTypes,
		fileSessionStarted,
		sjablonen,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

	function getFilesForDossierComponent(component) {
		if (documenten) {
			const folder = documenten.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}
	function getFilesForSjabloonComponent(component) {
		if (sjablonen) {
			const folder = sjablonen.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	return (
		<Section title="Vul het inhoudelijk voortgangsrapport in" color={color} disabled={disabled}>
			<Form
				title="Invulformulier verantwoording"
				name="verantwoording"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}>

				<Fieldset>
					<DownloadUploadFiles
						dossierId={vrVerantwoording.voortgangsrapportId}
						voortgangsrapportId={vrVerantwoording.voortgangsrapportId}
						title="Bewijsstukken van gemaakte kosten"
						disabled={disabled}
						color={color}
						size={12}
						tab={domainConstants.DocumentTab.VRVerantwoording}
						component={domainConstants.ComponentName.BewijsstukkenGemaakteKosten}
						files={getFilesForDossierComponent(domainConstants.ComponentName.BewijsstukkenGemaakteKosten)}
						onDelete={mapDeleteFile(domainConstants.ComponentName.BewijsstukkenGemaakteKosten)}
						onDrop={mapDropFiles(domainConstants.ComponentName.BewijsstukkenGemaakteKosten)}
						fileTypes={fileTypes.BewijsstukkenGemaakteKosten}
						validationMessage={errors ? errors.ulBewijsstukkenGemaakteKosten : ''}
						validationMessageType={validationMessageType}
						fileSessionStarted={fileSessionStarted}
						tooltip={"Goedgekeurde facturen, vorderingsstaten of andere bewijsstukken die de gemaakte sportgerelateerde investeringskosten verantwoorden."}
						tooltipIconColor={types.COLOR_WHITE}
						tooltipWindowWidth={35} />
				</Fieldset>
				<Fieldset>
					<DownloadUploadFiles
						dossierId={vrVerantwoording.voortgangsrapportId}
						title="Sjabloon overzicht en toelichting bewijsstukken"
						size={6}
						disabled={disabled}
						tab={"Voortgangsrapport/" + domainConstants.DocumentTab.VRVerantwoording}
						component={domainConstants.ComponentName.ToelichtingGemaakteKosten}
						files={getFilesForSjabloonComponent(domainConstants.ComponentName.ToelichtingGemaakteKosten)}
						color={color}
						fileSessionStarted={fileSessionStarted} />
					<DownloadUploadFiles
						dossierId={vrVerantwoording.voortgangsrapportId}
						voortgangsrapportId={vrVerantwoording.voortgangsrapportId}
						title="Overzicht en toelichting bewijsstukken"
						disabled={disabled}
						color={color}
						size={6}
						tab={domainConstants.DocumentTab.VRVerantwoording}
						component={domainConstants.ComponentName.ToelichtingGemaakteKosten}
						files={getFilesForDossierComponent(domainConstants.ComponentName.ToelichtingGemaakteKosten)}
						onDelete={mapDeleteFile(domainConstants.ComponentName.ToelichtingGemaakteKosten)}
						onDrop={mapDropFiles(domainConstants.ComponentName.ToelichtingGemaakteKosten)}
						fileTypes={fileTypes.ToelichtingGemaakteKosten}
						validationMessage={errors ? errors.ulToelichtingGemaakteKosten : ''}
						validationMessageType={validationMessageType}
						fileSessionStarted={fileSessionStarted}
						tooltip={"Overzicht en toelichting van de goedgekeurde facturen, vorderingsstaten of andere bewijsstukken die de gemaakte sportgerelateerde investeringskosten verantwoorden."}
						tooltipIconColor={types.COLOR_WHITE}
						tooltipWindowWidth={35} />
				</Fieldset>
				<Fieldset>
					<Row>
						<NumberInput
							key="totaalbedragExclBTW"
							name="totaalbedragExclBTW"
							label="Totaalbedrag excl BTW"
							onChange={onChange}
							value={vrVerantwoording.totaalbedragExclBTW}
							maxLength={100}
							disabled={disabled}
							size={6}
							isValuta
							validationMessage={errors ? errors.totaalbedragExclBTW : ''}
							validationMessageType={validationMessageType}
							tooltip={"Totaal van de meegestuurde verantwoordingsstukken in EUR excl BTW"}
							tooltipWindowWidth={26.5} />
						<NumberInput
							key="totaalbedragInclBTW"
							name="totaalbedragInclBTW"
							label="Totaalbedrag incl BTW"
							onChange={onChange}
							value={vrVerantwoording.totaalbedragInclBTW}
							maxLength={100}
							size={6}
							isValuta
							disabled={disabled}
							validationMessage={errors ? errors.totaalbedragInclBTW : ''}
							validationMessageType={validationMessageType}
							tooltip={"Totaal van de meegestuurde verantwoordingsstukken in EUR incl BTW"}
							tooltipWindowWidth={26.5}
						/>
					</Row>
				</Fieldset>
				<Fieldset>
					<DownloadUploadFiles
						dossierId={vrVerantwoording.voortgangsrapportId}
						voortgangsrapportId={vrVerantwoording.voortgangsrapportId}
						title="Voorlopig opleveringsverslag"
						disabled={disabled}
						color={color}
						size={12}
						tab={domainConstants.DocumentTab.VRVerantwoording}
						component={domainConstants.ComponentName.VoorlopigOpleveringsVerslag}
						files={getFilesForDossierComponent(domainConstants.ComponentName.VoorlopigOpleveringsVerslag)}
						onDelete={mapDeleteFile(domainConstants.ComponentName.VoorlopigOpleveringsVerslag)}
						onDrop={mapDropFiles(domainConstants.ComponentName.VoorlopigOpleveringsVerslag)}
						fileTypes={fileTypes.VoorlopigOpleveringsVerslag}
						validationMessage={errors ? errors.ulVoorlopigOpleveringsVerslag : ''}
						validationMessageType={validationMessageType}
						fileSessionStarted={fileSessionStarted}
						tooltip={"Het door de betrokken partijen ondertekende voorlopige opleveringsverslag."}
						tooltipIconColor={types.COLOR_WHITE}
						tooltipWindowWidth={30} />
				</Fieldset>
				<Fieldset>
					{vrVerantwoording.infraEnergetischDuurzaam ?
						<DownloadUploadFiles
							dossierId={vrVerantwoording.voortgangsrapportId}
							voortgangsrapportId={vrVerantwoording.voortgangsrapportId}
							title="Definitieve EPB-­aangifte"
							disabled={disabled}
							color={color}
							size={12}
							tab={domainConstants.DocumentTab.VRVerantwoording}
							component={domainConstants.ComponentName.DefinitieveEpbAangifte}
							files={getFilesForDossierComponent(domainConstants.ComponentName.DefinitieveEpbAangifte)}
							onDelete={mapDeleteFile(domainConstants.ComponentName.DefinitieveEpbAangifte)}
							onDrop={mapDropFiles(domainConstants.ComponentName.DefinitieveEpbAangifte)}
							fileTypes={fileTypes.DefinitieveEpbAangifte}
							validationMessage={errors ? errors.ulDefinitieveEpbAangifte : ''}
							validationMessageType={validationMessageType}
							fileSessionStarted={fileSessionStarted}
							tooltip={"Definitieve EPB aangifte (vermeld in artikel 8 van het besluit van de Vlaamse regering van 16 juni 2017) Uploaden in geval van nieuwbouw of ingrijpende energetische renovatie."}
							tooltipIconColor={types.COLOR_WHITE}
							tooltipWindowWidth={33} />
						:
						null
					}
				</Fieldset>
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
VRVerantwoordingForm.propTypes = {
	vrVerantwoording: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	projectId: PropTypes.string,
	documenten: PropTypes.array,
	onDropFiles: PropTypes.func,
	onDeleteFile: PropTypes.func,
	fileTypes: PropTypes.object,
	fileSessionStarted: PropTypes.bool,
	sjablonen: PropTypes.array.isRequired,
	validationMessageType: PropTypes.string
};

export default VRVerantwoordingForm;
